import PlainDropdownList from "../src/plain/PlainDropdownList.js";
export default class ElixDropdownList extends PlainDropdownList {}
customElements.define("elix-dropdown-list", ElixDropdownList);
